import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Constraint } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  constrainElements(data: Boundaries["constrainElements"]["request"]): void;
}

function useConstrainElements(constraint: Constraint): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isConstrainElementsRequestPending(constraint),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isConstrainElementsRequestSuccess(constraint),
    ),
    isRequestFailure: useSelector(() =>
      selector.isConstrainElementsRequestFailure(constraint),
    ),
    constrainElements: core.constrainElements,
  };
}

export { useConstrainElements };
